module.exports = __webpack_public_path__ + "img/danger.4f80da59.svg";